import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SendRoutingModule } from './send-routing.module';
import { SendComponent } from './views/send.component';
import { SendComponentStorageService } from './views/send.component.storage.service';

@NgModule({
  declarations: [
    SendComponent,
  ],
  imports: [
    CommonModule,
    SendRoutingModule,
    SharedModule,
    FormsModule,
  ],
  providers:[SendComponentStorageService]
})
export class SendModule { }
